import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class PerformanceCounterTypeService {
   async getPerformanceCounterTypes() {
      return http.get(`/performance-counter-types`, cacheFirstConfig).then((response: any) => {
         return response.data;
      });
   }
}
